export function globalcolorTextComision(status: string) {
	const st = status.toLowerCase();

	if (st === "preview") {
		return "#2563eb"; // blue-600
	}
	if (st === "paid") {
		return "#43b897 "; // green-600
	}
	if (st === "canceled") {
		return "#C71585 "; // red-600
	}
	if (st === "suspended") {
		return "#dc2626"; // red-600
	}
	if (st === "open") {
		return "#6b7280"; // gray-500
	}
	if (st === "not_eligible") {
		return "#b45309"; // amber-700
	}

	return "#374151"; // gray-700
}

export function globalcolorBackGroundComission(status: string) {
	const st = status.toLowerCase();

	if (st === "preview") {
		return "#F5F8FC"; // blue-100
	}
	if (st === "paid") {
		return "#e9f8f5"; // green-100
	}
	if (st === "canceled") {
		return "#fcedea "; // red-100
	}
	if (st === "suspended") {
		return "#fee2e2"; // red-100
	}
	if (st === "open") {
		return "#f3f4f6"; // gray-100
	}
	if (st === "not_eligible") {
		return "#fef3c7"; // amber-100
	}

	// Fallback
	return "#f9fafb"; // gray-50
}
